import { EVENT_CLOSE_WITHDRAW, EVENT_OPEN_WITHDRAW } from "@components/utils/WithdrawDrawer";

export function openWithdraw() {
  window.dispatchEvent(new CustomEvent(EVENT_OPEN_WITHDRAW));
}

export type CloseWithdrawOptions = {
  isNotEndHijack?: boolean;
};

export function closeWithdraw(options: CloseWithdrawOptions = {}) {
  window.dispatchEvent(
    new CustomEvent<CloseWithdrawOptions>(EVENT_CLOSE_WITHDRAW, {
      detail: options,
    }),
  );
}
